import { useEffect, useState } from "react";

let deferredPrompt = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    emit();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    emit();
  });
}

const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
export const isIOS = /iphone|ipad|ipod/i.test(ua) && !/windows phone/i.test(ua);
export const isStandalone =
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);

export function usePwaInstall() {
  const [canInstall, setCanInstall] = useState(!!deferredPrompt);

  useEffect(() => {
    const l = () => setCanInstall(!!deferredPrompt);
    listeners.add(l);
    l();
    return () => listeners.delete(l);
  }, []);

  const promptInstall = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    emit();
    return outcome === "accepted";
  };

  return { canInstall, isIOS, isStandalone, promptInstall };
}
